const loraTitleCommonStyles = {
  fontFamily: 'Lora',
  fontStyle: 'italic',
  fontSize: '36px',
  color: 'text.darkBlue',
  lineHeight: '48px',
  textAlign: 'center',
};

const urbanistCommonStyles = {
  fontFamily: 'Urbanist',
  fontSize: '14px',
  lineHeight: '16.8px',
  color: 'text.mediumBlue',
};

export default {
  Text: {
    defaultProps: {
      size: 'md',
      fontFamily: 'Urbanist',
      color: 'text.mediumGray',
    },
    baseStyle: {
      lineHeight: '26px',
      fontWeight: '400',
    },
    variants: {
      lora: {
        fontFamily: 'Lora',
        fontStyle: 'italic',
      },
      loraItalic: {
        fontFamily: 'Lora',
        fontStyle: 'italic',
        fontWeight: '400',
        fontSize: '16px',
        lineHeight: '19px',
      },
      loraRegular18: {
        fontFamily: 'Lora',
        fontStyle: 'italic',
        fontWeight: '400',
        fontSize: '18px',
        lineHeight: '21px',
      },
      loraMedium18: {
        fontFamily: 'Lora',
        fontStyle: 'italic',
        fontWeight: '500',
        fontSize: '18px',
        lineHeight: '21px',
      },
      loraTitle: {
        ...loraTitleCommonStyles,
        fontSize: '32px',
        lineHeight: '40px',
        fontWeight: '500',
      },
      loraExtraSmallTitle: {
        ...loraTitleCommonStyles,
        fontSize: '20px',
        lineHeight: '25px',
        fontWeight: '400',
      },
      loraSmallTitle: {
        ...loraTitleCommonStyles,
        fontSize: '24px',
        lineHeight: '32px',
        fontWeight: '400',
      },
      loraSectionTitle: {
        ...loraTitleCommonStyles,
        fontSize: '26px',
        fontWeight: 500,
        fontStyle: 'italic',
        lineHeight: '28px',
        color: 'text.mediumBlue',
      },
      loraItalicTitle: {
        ...loraTitleCommonStyles,
        fontWeight: '400',
      },
      loraMedium: {
        ...loraTitleCommonStyles,
        fontSize: '20px',
        lineHeight: '25px',
        fontWeight: '500',
      },
      loraMedium22: {
        ...loraTitleCommonStyles,
        fontSize: '22px',
        lineHeight: '25px',
        fontWeight: '500',
      },
      loraMediumTitle: {
        ...loraTitleCommonStyles,
        fontSize: '26px',
        lineHeight: '34px',
        fontWeight: '500',
      },
      loraMediumItalicTitle: {
        ...loraTitleCommonStyles,
        fontWeight: '500',
      },
      loraSemiBoldItalicTitle: {
        ...loraTitleCommonStyles,
        fontWeight: '600',
      },
      loraBoldItalicTitle: {
        ...loraTitleCommonStyles,
        fontWeight: '700',
      },
      urbanistRegular: {
        ...urbanistCommonStyles,
        fontWeight: '400',
      },
      urbanistMediumRegular: {
        fontWeight: '500',
        ...urbanistCommonStyles,
      },
      urbanistSmall: {
        ...urbanistCommonStyles,
        fontSize: '12px',
        lineHeight: '14px',
      },
      urbanistMedium: {
        ...urbanistCommonStyles,
        fontWeight: '500',
      },
      urbanistMediumLarge: {
        ...urbanistCommonStyles,
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '19px',
      },
      urbanistSemiBoldRegular: {
        ...urbanistCommonStyles,
        fontWeight: '600',
      },
      urbanistSemiBold: {
        ...urbanistCommonStyles,
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '19px',
        textAlign: 'center',
      },
      urbanistMedium18: {
        ...urbanistCommonStyles,
        fontWeight: '500',
        fontSize: '18px',
        lineHeight: '21.6px',
        textAlign: 'center',
      },
      urbanistSemiBoldLarge: {
        ...urbanistCommonStyles,
        fontWeight: '600',
        fontSize: '18px',
        lineHeight: '21.6px',
        textAlign: 'center',
      },
      urbanistBoldLarge: {
        ...urbanistCommonStyles,
        fontWeight: '700',
        fontSize: '18px',
        lineHeight: '21.6px',
        textAlign: 'center',
      },
      urbanistBlackLarge: {
        ...urbanistCommonStyles,
        fontWeight: '900',
        fontSize: '18px',
        lineHeight: '21.6px',
        textAlign: 'center',
      },
      urbanistSemiBoldTitle: {
        ...urbanistCommonStyles,
        fontWeight: '600',
        fontSize: '26px',
        lineHeight: '31px',
      },
      urbanistSemiBoldSmallTitle: {
        ...urbanistCommonStyles,
        fontWeight: '600',
        fontSize: '20px',
        lineHeight: '24px',
      },
      urbanistBold: {
        ...urbanistCommonStyles,
        fontWeight: '700',
      },
      urbanistBold16: {
        ...urbanistCommonStyles,
        fontWeight: '700',
        fontSize: '16px',
      },
      urbanistBold14: {
        ...urbanistCommonStyles,
        fontWeight: '700',
        fontSize: '14px',
      },
      urbanistBold20: {
        ...urbanistCommonStyles,
        fontWeight: '700',
        fontSize: '20px',
      },
      urbanistExtraBold: {
        ...urbanistCommonStyles,
        fontWeight: '800',
      },
      urbanistExtraBold16: {
        ...urbanistCommonStyles,
        fontWeight: '800',
        fontSize: '16px',
      },
      urbanistMaximumBold: {
        ...urbanistCommonStyles,
        fontWeight: '900',
      },
      urbanistMaximumBold12: {
        ...urbanistCommonStyles,
        fontWeight: '900',
        fontSize: '12px',
      },
      urbanistMaximumBold10: {
        ...urbanistCommonStyles,
        fontWeight: '900',
        fontSize: '10px',
      },
      urbanistExtraBoldSmall: {
        ...urbanistCommonStyles,
        fontWeight: '800',
        fontSize: '10px',
        lineHeight: '12px',
      },
      urbanistExtraBoldSmall12: {
        ...urbanistCommonStyles,
        fontWeight: '800',
        fontSize: '12px',
        lineHeight: '14px',
      },
      urbanistSmallBold: {
        ...urbanistCommonStyles,
        fontSize: '12px',
        lineHeight: '14px',
        fontWeight: 700,
      },
      urbanistTitleLarge: {
        fontSize: '36px',
        lineHeight: '43px',
        textAlign: 'center',
        color: 'text.veryLightBlue',
        opacity: '0.7',
      },
      urbanistTitleMedium: {
        ...urbanistCommonStyles,
        fontSize: '30px',
        lineHeight: '36px',
        fontWeight: '700',
      },
      urbanistTitleBold: {
        ...urbanistCommonStyles,
        fontSize: '30px',
        lineHeight: '36px',
        fontWeight: '800',
      },
      errorSmall: {
        ...urbanistCommonStyles,
        color: 'extra.red',
        fontSize: '12px',
        lineHeight: '14px',
        fontWeight: 500,
      },
      errorYellow: {
        ...urbanistCommonStyles,
        color: 'extra.yellowStrong',
        fontSize: '12px',
        lineHeight: '14px',
        paddingLeft: '16px',
        paddingTop: '4px',
        fontWeight: 500,
      },
      error: {
        ...urbanistCommonStyles,
        color: 'extra.red',
        fontWeight: 500,
        textAlign: 'center',
      },
      assessmentQuestionTitle: {
        ...urbanistCommonStyles,
        fontSize: '18px',
        lineHeight: '22px',
        fontWeight: 500,
        textAlign: 'center',
        color: '#004179',
        marginTop: '40px',
      },
      assessmentQuestionText: {
        fontFamily: 'lora',
        fontSize: '16px',
        lineHeight: '20px',
        fontWeight: 400,
        textAlign: 'center',
        color: '#004179',
        marginBottom: '20px',
        fontStyle: 'italic',
        marginTop: '20px',
      },
    },
  },
};
